/*
 * Mostek zgodnosci dla bledu Buyer Personalization OwnPrint.
 *
 * TO JEST OBEJSCIE BLEDU, NIE ARCHITEKTURA PERSONALIZACJI.
 * Szczegoly bledu: neckle/OWNPRINT_BUG_KAFLE_CHECKBOX_2026-08-22.md
 *
 * Aplikacja OwnPrint renderuje trzy typy kontrolek, ale w wydanym
 * personalization.js obsluguje tylko swatche. data-ownprint-tile
 * i data-ownprint-checkbox nie maja ZADNEJ obslugi - klikanie ich nic nie robi,
 * wiec klient nie moze wybrac kamienia ani grawerunku, a wariant Shopify
 * i cena zostaja na wartosciach domyslnych.
 *
 * Mostek ustawia wartosc na ukrytym inpucie OwnPrint i wysyla 'change'. Cala
 * reszta - rozwiazanie wariantu, przeliczenie ceny, odsloniecie pola
 * warunkowego - dzieje sie w ICH wlasnym kodzie. Dodatkowo duza siatka
 * birthstone jest progresywnie chowana w dostepnym akordeonie. Nie znamy
 * i nie wymyslamy nazw wariantow: wartosci i etykiety czytamy z DOM OwnPrint.
 *
 * Samowylaczanie: mostek dziala jako WYPELNIACZ LUKI, nie jako przechwytywacz.
 * Po kliknieciu czeka jeden tick i dziala tylko wtedy, gdy nikt nie zmienil
 * wartosci. Gdy OwnPrint naprawi swoj handler, mostek po prostu nigdy nie
 * wejdzie w akcje - bez sprawdzania wersji skryptu, ktore byloby kruche.
 */
(() => {
  const root = document.querySelector('[data-ownprint-personalization]');
  if (!root) return;

  // Ten mostek na biezaco podmienia tekst w tym korzeniu (patrz nizej). Jesli
  // przegladarka gosc rownolegle wlaczy wlasne auto-tlumaczenie (np. Chrome
  // Translate na PL stronie dla gosc z EN), oba mechanizmy walcza o ten sam
  // DOM - migotanie albo hybrydowy tekst. Wylaczamy auto-tlumaczenie tylko
  // tutaj, nie na calej stronie - reszta motywu (w tym przyszle EN) ma dzialac
  // normalnie z natywnymi tlumaczeniami Shopify Markets.
  root.setAttribute('translate', 'no');
  root.classList.add('notranslate');

  const POLE = '.ownprint-personalization__field';

  const i18nNode = document.querySelector('[data-neckle-product-i18n]');
  let i18n = {};
  try { i18n = i18nNode ? JSON.parse(i18nNode.textContent) : {}; } catch (error) { i18n = {}; }
  const tekst = (key, fallback) => i18n[key] || fallback;
  const wstaw = (template, token, value) => template.replace(token, value);
  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');

  // Tłumaczymy wyłącznie widoczne węzły tekstowe. Wartości inputów, nazwy
  // opcji, warianty i line-item properties pozostają dokładnie takie, jak
  // zwraca je OwnPrint — dzięki temu copy jest polskie bez naruszania kontraktu.
  const tlumaczeniaWidocznegoTekstu = isEnglish ? [
    [/Tekst (?:graweru|napisu) z tyłu/gi, 'Back engraving text'],
    [/bez graweru z tyłu/gi, 'Without back engraving'],
    [/z grawerem z tyłu/gi, 'With back engraving'],
    [/(?:Grawer|Napis) z tyłu/gi, 'Back engraving'],
    [/Kamień urodzeniowy/gi, 'Birthstone'],
    [/Zdjęcie pupila/gi, 'Pet photo'],
    [/Imię pupila/gi, 'Pet name'],
    [/Wykończenie|Plating/gi, 'Finish'],
    [/Pasek/gi, 'Band color'],
    [/18k Różowe|Różowe złoto 18K|18K Rose Gold Plated/gi, '18k Rose Gold Plated'],
    [/18k Złote|Złote 18K/gi, '18k Gold Plated'],
    [/Srebrna Stal|Srebne|Silver Steel/gi, 'Silver'],
    [/Brązowy pasek|Brown Leather/gi, 'Brown'],
    [/Czarny pasek|Black Leather/gi, 'Black'],
    [/Opcjonalnie/gi, 'Optional'],
    [/^\s*Tak\s*$/gi, 'Yes'],
    [/Styczeń/gi, 'January'],
    [/Luty/gi, 'February'],
    [/Marzec/gi, 'March'],
    [/Kwiecień/gi, 'April'],
    [/Maj/gi, 'May'],
    [/Czerwiec/gi, 'June'],
    [/Lipiec/gi, 'July'],
    [/Sierpień/gi, 'August'],
    [/Wrzesień/gi, 'September'],
    [/Październik/gi, 'October'],
    [/Listopad/gi, 'November'],
    [/Grudzień/gi, 'December'],
  ] : [
    [/Pet name/gi, 'Imi\u0119 pupila'],
    [/18K Rose Gold Plated/gi, 'Różowe złoto 18K'],
    [/18k Gold Plated/gi, 'Złote 18K'],
    [/Silver Steel/gi, 'Srebrna stal'],
    [/Without back engraving/gi, 'Bez graweru z tyłu'],
    [/With back engraving/gi, 'Z grawerem z tyłu'],
    [/Back engraving/gi, 'Grawer z tyłu'],
    [/Birthstone/gi, 'Kamień urodzeniowy'],
    [/Pet photo/gi, 'Zdjęcie pupila'],
    [/Plating/gi, 'Wykończenie'],
    [/Optional/gi, 'Opcjonalnie'],
    [/^\s*Yes\s*$/gi, 'Tak'],
  ];

  const przetlumaczWidoczneTeksty = () => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      const parent = node.parentElement;
      if (parent && !parent.closest('script,style,select,option')) {
        let tekst = node.nodeValue;
        tlumaczeniaWidocznegoTekstu.forEach(([wzorzec, zamiana]) => { tekst = tekst.replace(wzorzec, zamiana); });
        if (tekst !== node.nodeValue) node.nodeValue = tekst;
      }
      node = walker.nextNode();
    }
  };

  // Ukryty input OwnPrint sterujacy opcja wariantu dla danego pola. Ten sam
  // element niesie data-ownprint-option-name oraz wartosci on/off checkboxa,
  // wiec nie trzeba zgadywac powiazania grupa -> opcja.
  const inputOpcji = (el) => el.closest(POLE)?.querySelector('[data-ownprint-option-name]') || null;

  const ustaw = (input, wartosc) => {
    if (!input || input.value === wartosc) return false;
    input.value = wartosc;
    // Pod 'change' podpiete sa ich apply() (wariant + cena) i evaluate()
    // (pola warunkowe). To jedyne, czego mostek potrzebuje.
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  // Uzupelnij dopiero, gdy okaze sie, ze OwnPrint tego nie zrobil.
  const uzupelnijGdyLuka = (input, oczekiwana) => {
    if (!input) return;
    const przed = input.value;
    window.setTimeout(() => {
      if (input.value !== przed) return; // OwnPrint zadzialal sam - nie wchodzimy
      ustaw(input, oczekiwana);
    }, 0);
  };

  const podepnijKafle = () => {
    root.querySelectorAll('[data-ownprint-tile]').forEach((kafel) => {
      if (kafel.dataset.neckleBridge) return;
      kafel.dataset.neckleBridge = '1';
      kafel.addEventListener('click', () => {
        const wartosc = kafel.getAttribute('data-ownprint-tile');
        if (!wartosc) return;
        const grupa = kafel.closest('[data-ownprint-tile-group]');
        uzupelnijGdyLuka(inputOpcji(kafel), wartosc);
        // Stan wizualny grupy - OwnPrint tez go nie ustawia.
        window.setTimeout(() => {
          if (!grupa) return;
          grupa.querySelectorAll('[data-ownprint-tile]').forEach((k) => {
            const aktywny = k === kafel;
            k.setAttribute('aria-checked', String(aktywny));
            k.classList.toggle('is-selected', aktywny);
          });
        }, 0);
      });
    });
  };

  const podepnijAkordeonKamieni = () => {
    root.querySelectorAll('[data-ownprint-tile-group]').forEach((grupa) => {
      if (grupa.closest('[data-neckle-birthstone-accordion]')) return;
      const input = inputOpcji(grupa);
      if (input?.getAttribute('data-ownprint-option-name')?.toLowerCase() !== 'birthstone') return;

      const kafle = [...grupa.querySelectorAll('[data-ownprint-tile]')];
      if (!kafle.length) return;

      const pole = grupa.closest(POLE);
      const etykieta = pole?.querySelector('.ownprint-personalization__label');
      if (!pole || !etykieta) return;

      const akordeon = document.createElement('details');
      akordeon.className = 'neckle-birthstone-accordion';
      akordeon.setAttribute('data-neckle-birthstone-accordion', '');

      const naglowek = document.createElement('summary');
      naglowek.className = 'neckle-birthstone-accordion__summary';
      const tytul = document.createElement('span');
      tytul.className = 'neckle-birthstone-accordion__title';
      tytul.textContent = etykieta.textContent.replace(/\s+/g, ' ').trim();
      const wybor = document.createElement('span');
      wybor.className = 'neckle-birthstone-accordion__value';
      wybor.setAttribute('data-neckle-birthstone-value', '');
      wybor.setAttribute('role', 'status');
      wybor.setAttribute('aria-live', 'polite');
      const miniatura = document.createElement('img');
      miniatura.className = 'neckle-birthstone-accordion__thumbnail';
      miniatura.alt = '';
      miniatura.width = 28;
      miniatura.height = 28;
      miniatura.hidden = true;
      const wyborTekst = document.createElement('span');
      wybor.append(miniatura, wyborTekst);
      naglowek.append(tytul, wybor);
      akordeon.appendChild(naglowek);

      const pokazWybor = () => {
        kafle.forEach((kafel) => {
          const aktywny = kafel.getAttribute('data-ownprint-tile') === input.value;
          kafel.setAttribute('aria-checked', String(aktywny));
          kafel.classList.toggle('is-selected', aktywny);
          if (aktywny) {
            const nazwa = kafel.getAttribute('title')
              || kafel.querySelector('.ownprint-personalization__tile-name')?.textContent?.trim()
              || input.value;
            const potwierdzony = akordeon.dataset.neckleConfirmed === 'true';
            const grafika = kafel.querySelector('.ownprint-personalization__tile-img');
            wyborTekst.textContent = potwierdzony
              ? wstaw(tekst('selected', 'Wybrano: __VALUE__'), '__VALUE__', nazwa)
              : nazwa;
            if (potwierdzony && grafika?.src) {
              miniatura.src = grafika.src;
              miniatura.hidden = false;
            } else {
              miniatura.removeAttribute('src');
              miniatura.hidden = true;
            }
          }
        });
      };

      input.addEventListener('change', pokazWybor);
      grupa.addEventListener('click', (event) => {
        if (!(event.target instanceof Element) || !event.target.closest('[data-ownprint-tile]')) return;
        window.setTimeout(() => {
          akordeon.dataset.neckleConfirmed = 'true';
          akordeon.classList.add('is-confirmed');
          pokazWybor();
          akordeon.open = false;
        }, 0);
      });

      pole.before(akordeon);
      akordeon.appendChild(pole);
      pokazWybor();
    });
  };

  const odswiezStanGraweru = (cb) => {
    const pole = cb.closest('.neckle-engraving-field');
    if (!pole) return;
    const stan = pole.querySelector('[data-neckle-engraving-state]');
    pole.classList.toggle('is-enabled', cb.checked);
    const tekstStanu = cb.checked ? tekst('added', 'Dodano') : tekst('optional', 'Opcjonalnie');
    if (stan && stan.textContent !== tekstStanu) stan.textContent = tekstStanu;
  };

  const polaczPoleGraweru = (cb) => {
    const pole = cb.closest(POLE);
    const input = inputOpcji(cb);
    const nazwaOpcji = input?.getAttribute('data-ownprint-option-name')?.trim().toLowerCase();
    if (!pole || !nazwaOpcji) return;

    // OwnPrint nie musi renderowac pola warunkowego obok checkboxa. Laczymy je
    // po kontrakcie opcji, a nie po polozeniu w drzewie DOM.
    const poleWarunkowe = [...root.querySelectorAll('[data-ownprint-conditional]')].find((kandydat) => (
      kandydat.getAttribute('data-ownprint-when-option')?.trim().toLowerCase() === nazwaOpcji
    ));
    if (!poleWarunkowe) return;

    pole.classList.add('neckle-engraving-field');
    poleWarunkowe.classList.add('neckle-engraving-field__conditional');
    if (poleWarunkowe.parentElement !== pole) pole.appendChild(poleWarunkowe);

    const etykieta = cb.closest('.ownprint-personalization__check')
      ?.querySelector('.ownprint-personalization__check-label');
    if (['tak', 'yes'].includes(etykieta?.textContent.trim().toLowerCase())) {
      etykieta.textContent = tekst('addEngraving', 'Dodaj grawer');
    }

    let stan = pole.querySelector('[data-neckle-engraving-state]');
    if (!stan) {
      stan = document.createElement('span');
      stan.className = 'neckle-engraving-field__state';
      stan.setAttribute('data-neckle-engraving-state', '');
      stan.setAttribute('aria-live', 'polite');
      cb.closest('.ownprint-personalization__check')?.appendChild(stan);
    }
    odswiezStanGraweru(cb);
  };

  const podepnijCheckboxy = () => {
    root.querySelectorAll('[data-ownprint-checkbox]').forEach((cb) => {
      polaczPoleGraweru(cb);
      if (cb.dataset.neckleBridge) return;
      cb.dataset.neckleBridge = '1';
      cb.addEventListener('change', () => {
        odswiezStanGraweru(cb);
        const input = inputOpcji(cb);
        if (!input) return;
        const wartosc = cb.checked
          ? input.getAttribute('data-ownprint-checkbox-on')
          : input.getAttribute('data-ownprint-checkbox-off');
        if (wartosc == null) return;
        uzupelnijGdyLuka(input, wartosc);
      });
    });
  };

  const skanuj = () => { przetlumaczWidoczneTeksty(); podepnijKafle(); podepnijAkordeonKamieni(); podepnijCheckboxy(); };
  skanuj();
  new MutationObserver(skanuj).observe(root, { childList: true, subtree: true });

  /* ---------------- Walidacja przed dodaniem do koszyka (fail closed) ----------------
     Nasz motyw przechwytuje submit na window w fazie capture ze
     stopImmediatePropagation(), wiec initCartSubmit OwnPrint - a w nim ICH
     walidacja data-ownprint-required - nigdy sie nie wykonuje. Bez tego mostek
     odslonilby pole graweru, klient moglby zostawic je puste, a zamowienie
     przeszloby z wariantem "With back engraving" i pustym tekstem. To byloby
     gorsze niz blad, ktory naprawiamy. */

  const daneWariantow = () => {
    try {
      const node = root.querySelector('[data-ownprint-variant-data]');
      return node ? JSON.parse(node.textContent) : null;
    } catch (e) { return null; }
  };

  const widoczne = (el) => !!(el.offsetParent || el.getClientRects().length);

  // OwnPrint oznacza "wymagane" niespojnie miedzy polami: pole graweru dostaje
  // ich wlasny atrybut data-ownprint-required, ale np. zdjecie pupila i imie
  // pupila maja tylko natywny HTML required. Ich input nie jest w naszym
  // <form> (jest osobnym elementem w buy-boxie), wiec natywna walidacja
  // przegladarki i tak by go nie zlapala - musimy sprawdzic oba warianty sami.
  const WYMAGANE_SELEKTOR = '[data-ownprint-required], [required]';

  // Pole graweru rozpoznajemy po kontrakcie opcji OwnPrint (data-ownprint-when-option
  // zawiera "engraving"), a nie po klasie dodawanej przez polaczPoleGraweru - dzieki
  // temu komunikat dziala nawet, gdyby kolejnosc laczenia pol kiedys sie zmienila.
  const jestPoleGraweru = (pole) => {
    const opcja = pole.closest('[data-ownprint-conditional]')
      ?.getAttribute('data-ownprint-when-option')?.trim().toLowerCase();
    return !!opcja && opcja.includes('engraving');
  };

  const wiadomoscDlaPola = (pole) => {
    if (pole.type === 'file') return tekst('addPhoto', 'Dodaj zdjęcie pupila.');
    if (jestPoleGraweru(pole)) return tekst('enterBackEngraving', 'Wpisz tekst graweru z tyłu.');
    const etykieta = pole.closest(POLE)?.querySelector('.ownprint-personalization__label')?.textContent;
    return wstaw(
      tekst('completeField', 'Uzupełnij pole: __FIELD__.'),
      '__FIELD__',
      (etykieta || tekst('required', 'wymagane')).replace('*', '').trim(),
    );
  };

  const problemy = () => {
    const lista = [];

    // 1) Pola wymagane, ktore sa realnie widoczne dla klienta.
    root.querySelectorAll(WYMAGANE_SELEKTOR).forEach((pole) => {
      if (!widoczne(pole)) return;
      const pusty = pole.type === 'file' ? !(pole.files && pole.files.length) : !String(pole.value || '').trim();
      if (pusty) lista.push({ pole, wiadomosc: wiadomoscDlaPola(pole) });
    });

    // 2) Wybrana kombinacja musi odpowiadac istniejacemu wariantowi Shopify.
    const dane = daneWariantow();
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (dane && Array.isArray(dane.variants) && idInput) {
      const istnieje = dane.variants.some((v) => String(v.id) === String(idInput.value));
      if (!istnieje) lista.push({
        pole: null,
        wiadomosc: tekst('combinationUnavailable', 'Wybrana kombinacja opcji jest niedostępna.'),
      });
    }
    return lista;
  };

  // Czerwone oznaczenie brakujacego pola - dokladamy je do calego wrappera
  // OwnPrint (etykieta + input), zeby bylo widoczne niezaleznie od typu pola.
  const oznaczBledy = (lista) => {
    const bledne = new Set(lista.map((problem) => problem.pole).filter(Boolean));
    root.querySelectorAll(WYMAGANE_SELEKTOR).forEach((pole) => {
      const bledny = bledne.has(pole);
      const wrapper = pole.closest(POLE) || pole.closest('[data-ownprint-conditional]');
      wrapper?.classList.toggle('is-invalid', bledny);
      pole.classList.toggle('is-invalid', bledny);
      // Pole zdjecia jest wizualnie ukryte pod dropzone'em (neckle-dropzone.js) -
      // czerwone oznaczenie musi trafic na widoczny trigger, nie na sam input.
      pole.closest('.neckle-dropzone')?.querySelector('.neckle-dropzone__trigger')
        ?.classList.toggle('is-invalid', bledny);
      if (bledny) pole.setAttribute('aria-invalid', 'true');
      else pole.removeAttribute('aria-invalid');
    });
  };

  const pokazBledy = (lista) => {
    oznaczBledy(lista);

    let box = root.querySelector('[data-neckle-bridge-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-neckle-bridge-error', '');
      box.setAttribute('role', 'alert');
      box.className = 'neckle-bridge-error';
      root.appendChild(box);
    }
    const tekst = lista.map((problem) => problem.wiadomosc).join(' ');
    box.textContent = tekst;
    box.hidden = !tekst;

    // Przewin i ustaw fokus na pierwszym brakujacym polu; gdy blokuje tylko
    // niedostepna kombinacja wariantu (bez konkretnego pola), przewin do komunikatu.
    const pierwszePole = lista.find((problem) => problem.pole)?.pole;
    if (pierwszePole) {
      pierwszePole.scrollIntoView({ block: 'center', behavior: 'smooth' });
      pierwszePole.focus({ preventScroll: true });
    } else if (tekst) {
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  };

  // Po pierwszej zablokowanej probie wysylki sledzimy uzupelnianie pol na biezaco,
  // zeby komunikat i czerwone oznaczenie znikaly same, gdy klient poprawi dane -
  // bez czekania na kolejne kliknięcie "Dodaj do koszyka".
  let probowanoWyslac = false;
  const przewalidujNaZywo = () => {
    if (!probowanoWyslac) return;
    pokazBledy(problemy());
  };
  root.addEventListener('input', przewalidujNaZywo);
  root.addEventListener('change', przewalidujNaZywo);

  const strazSubmitu = (event) => {
    const cel = event.target;
    if (!(cel instanceof Element)) return;
    const dotyczyZakupu = cel.closest('[data-add-to-cart]') || cel.matches('form[action*="/cart/add"]');
    if (!dotyczyZakupu) return;

    const lista = problemy();
    if (!lista.length) { pokazBledy([]); return; }

    // Fail closed: blokujemy zakup zamiast dopuscic bledne zamowienie.
    probowanoWyslac = true;
    event.preventDefault();
    event.stopImmediatePropagation();
    pokazBledy(lista);
  };

  // Capture na window i wczesniejsza rejestracja niz neckle-product.js sprawiaja,
  // ze straz ma szanse zatrzymac submit, zanim motyw wykona wlasny POST.
  window.addEventListener('click', strazSubmitu, true);
  window.addEventListener('submit', strazSubmitu, true);
})();
